import { Link } from "react-router-dom";

const APP_ONELINK = "https://onelink.to/r6c4yw";

const navItems = [
  { label: "Individual", to: "/" },
  { label: "Partner", to: "/?section=tab-switcher" },
  { label: "Corporate", to: "/?section=tab-switcher" },
  { label: "Meet Our Team", to: "/team" },
  { label: "Associates", to: "/team" },
  { label: "Contact Us", to: "/?section=contact" },
];

const LabBookingNavBar = () => {
  return (
    <nav className="sticky top-0 z-50 bg-white/98 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="HealthismPlus" className="h-9 w-9" />
          <span className="text-lg font-bold text-[#1A1A1A]">
            healthism<span className="text-[#13B58E]">+</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-7">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="text-sm font-medium text-[#6B7A99] hover:text-[#13B58E] transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </div>

        <a
          href={APP_ONELINK}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 sm:px-5 py-2 sm:py-2.5 rounded-full font-semibold text-white text-[12px] sm:text-sm shrink-0"
          style={{
            background: "linear-gradient(90deg, #006B5A 0%, #27A28B 100%)",
          }}
        >
          <span className="hidden sm:inline">Download App</span>
          <span className="sm:hidden">App</span>
        </a>
      </div>
    </nav>
  );
};

export default LabBookingNavBar;
